import { render, staticRenderFns } from "./TextBadge.vue?vue&type=template&id=2e649fbe&"
import script from "./TextBadge.vue?vue&type=script&lang=js&"
export * from "./TextBadge.vue?vue&type=script&lang=js&"
import style0 from "./TextBadge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports